import { ReactComponent as Rohbau } from "../assets/svg/Hausanschluss/Rohbau.svg";
import { ReactComponent as Bauversorgung } from "../assets/svg/Hausanschluss/Bauversorgung.svg";
import { ReactComponent as UmbauenUndSanieren } from "../assets/svg/Hausanschluss/UmbauenUndSanieren.svg";
import { ReactComponent as UmbauenUndSanierenBusiness } from "../assets/svg/Hausanschluss/UmbauenUndSanierenBusiness.svg";
import "./components.scss";
import Card from "../assets/card/card";
import "./popupPosition.scss";
import { PopupForms , Metalink } from "../assets/PopupForms/PopupForms";

export function HausanschlussPrivateCards(props: {text: any}) {
  return <>
      <Card
        topicSVG={<Rohbau />}
        headline={props.text.Hausanschluss.Rohbau.headline}
        text={props.text.Hausanschluss.Rohbau.text}
        buttonFunction={() => {window.open(props.text.Hausanschluss.Rohbau.link,'_self')}}
        item="item-1"
        data-testid="item"
      />
      <Card
        topicSVG={<Bauversorgung />}
        headline={props.text.Hausanschluss.Bauversorgung.headline}
        text={props.text.Hausanschluss.Bauversorgung.text}
        buttonFunction={() => {window.open(props.text.Hausanschluss.Bauversorgung.link,'_self')}}
        item="item-2"
        data-testid="item"
      />
      <Card
        topicSVG={<UmbauenUndSanieren />}
        headline={props.text.Hausanschluss.Umbau.headline}
        text={props.text.Hausanschluss.Umbau.text}
        buttonFunction={() => {window.open(`${props.text.Hausanschluss.Umbau.link}`,'_self')}}
        item="item-3"
        data-testid="item"
      />
  </>
}

export function HausanschlussBusinessCards(props: {text: any}) {
  return <>
      <Card
        topicSVG={<Rohbau />}
        headline={props.text.Hausanschluss.Rohbau_business.headline}
        text={props.text.Hausanschluss.Rohbau_business.text}
        buttonFunction={() => {window.open(props.text.Hausanschluss.Rohbau_business.link,'_self')}}
        item="item-1"
        data-testid="item"
      />
      <Card
        topicSVG={<Bauversorgung />}
        headline={props.text.Hausanschluss.Bauversorgung_business.headline}
        text={props.text.Hausanschluss.Bauversorgung_business.text}
        buttonFunction={() => {window.open(props.text.Hausanschluss.Bauversorgung_business.link,'_self')}}
        item="item-2"
        data-testid="item"
      />
      <Card
        topicSVG={<UmbauenUndSanierenBusiness />}
        headline={props.text.Hausanschluss.Umbau_business.headline}
        text={props.text.Hausanschluss.Umbau_business.text}
        buttonFunction={() => {window.open(props.text.Hausanschluss.Umbau_business.link,'_self')}}
        item="item-3"
        data-testid="item"
      />
  </>
}



export function HausanschlussPopupContainer (props: {setPopupState: Function, text: any}) {
  return <PopupForms
  buttonSecondaryFunction={() => {props.setPopupState()}}
  >
    <>
      <Metalink linkText="Bauherreninformation" function={() => {window.open(props.text.Hausanschluss.Mehr.Bauherreninformation,'_self')}}/>
      <Metalink linkText="Recht & Technik" function={() => {window.open(props.text.Hausanschluss.Mehr.RechtUndTechnik,'_self')}}/>
      <Metalink linkText="Produkte und Preise" function={() => {window.open(props.text.Hausanschluss.Mehr.Produktpreise,'_self')}}/>
      <Metalink linkText="Formulare" function={() => {window.open(props.text.Hausanschluss.Mehr.Formulare,'_self')}}/>
    </>
  </PopupForms>
}

export function HausanschlussBusinessPopupContainer (props: {setPopupState: Function, text: any}) {
  return (
    <PopupForms
    buttonSecondaryFunction={() => {props.setPopupState()}}
    >
      <>
        <Metalink linkText="Bauherreninformation" function={() => {window.open(props.text.Hausanschluss.Mehr_business.Bauherreninformation,'_self')}}/>
        <Metalink linkText="Recht & Technik" function={() => {window.open(props.text.Hausanschluss.Mehr_business.RechtUndTechnik,'_self')}}/>
        <Metalink linkText="Produkte und Preise" function={() => {window.open(props.text.Hausanschluss.Mehr_business.Produktpreise,'_self')}}/>
        <Metalink linkText="Formulare" function={() => {window.open(props.text.Hausanschluss.Mehr_business.Formulare,'_self')}}/>
      </>
    </PopupForms>
  )
}
